import {createApi} from "@reduxjs/toolkit/query/react"
import {apiConfig} from "../../utils/api-config"
import {
  BranchesTableResponse,
  ResponseBranches,
  ResponseCities
} from "../../types/Branches"

export const branchesApi = createApi({
  reducerPath: "branchesApi",
  baseQuery: apiConfig,
  tagTypes: ["Branch"],
  endpoints: (builder) => ({
    getCities: builder.query<ResponseBranches, void>({
      query: () => "cities",
      providesTags: ["Branch"]
    }),
    getBranches: builder.query<ResponseCities, string | undefined>({
      query: (city_id) => `branches?city_id=${city_id}`,
      providesTags: ["Branch"]
    }),
    getDetailedBranches: builder.mutation<
      BranchesTableResponse,
      number | undefined
    >({
      query: (arg) => ({
        url: "branches",
        method: "POST",
        body: {
          city_id: arg
        }
      })
    })
  })
})

export const {
  useGetBranchesQuery,
  useGetCitiesQuery,
  useGetDetailedBranchesMutation
} = branchesApi
